<template>
    <div class="flex-container">
        <div class="header">
            <div>{{$translate('Choose optional resource')}} {{$translate('for')}} {{resourceName}}</div>
            <v-progress-circular v-if="loading" color="primary" indeterminate size="32"></v-progress-circular>
            <v-text-field
                v-if="!loading && resources.length >= 5"
                v-model="search"
                append-icon="mdi-magnify"
                :label="$translate('Search...')"
                single-line
                hide-details></v-text-field>
        </div>

        <div class="overflow-y-auto content">
            <div v-for="resource in filteredResources" :key="resource.id">
                <v-checkbox
                    v-model="resource.selected"
                    :label="resource.name"
                    :disabled="disabled || resource.disabled"
                    class="align-center"
                    dense
                    hide-details
                    @change="() => $emit('select', resource.id, resource.selected)"
                >
                    <template v-slot:label>
                        <div @click.stop.prevent="doShowStaffInfoDialog(resource.id)">
                            <v-avatar class="mr-2">
                                <v-auto-img :src="resource.imagekey" />
                            </v-avatar>
                            <span :class="{'primary--text': !(disabled || resource.disabled)}">
                                {{resource.name}}
                            </span>
                        </div>
                    </template>
                </v-checkbox>
            </div>
        </div>
        <staff-info-dialog v-model="showStaffInfoDialog" :staffId="showStaff" />
    </div>
</template>

<style scoped>
.flex-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.content {
  flex: 1; /* Ta upp all tillgänglig plats efter header */
  overflow-y: auto;
}
</style>


<script>
import {isEqual} from 'lodash';
import StaffInfoDialog from '../components/StaffInfoDialog.vue'

export default {
    name: 'zoezi-optional-resources',
    zoezi: {
        title: 'Optional resources',
        icon: 'mdi-cog-outline'
    },

    props: {
        bookings: {
            type: Array,
            required: true
        },
        resourceName: {
            type: String,
            required: true
        },
        resourceIds: {
            type: Array,
            required: true
        },
        allResources: {
            type: Array,
            required: true
        },
        selectedResourceIds: {
            type: Array,
            required: true
        },
        pendingSelections: {
            type: Array,
            default: () => []
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    components: {
        StaffInfoDialog
    },
    watch: {
        resourceIds(newValue, oldValue) {
            if (!isEqual(newValue, oldValue)) {
                this.getResources();
            }
        },
        resourceName() {
            this.getResources();
        },
        bookings() {
            this.getResources();
        },
        pendingSelections(newValue, oldValue) {
            if (!isEqual(newValue, oldValue)) {
                this.getResources();
            }
        }
    },

    computed: {
        filteredResources() {
            let s = this.search?.toLowerCase();
            return this.resources.filter(x => !x.disabled || x.selected).filter(x => !s || x.name.toLowerCase().includes(s)).sort((a,b) => a.name.localeCompare(b.name));
        }
    },

    data: () => ({
        resources: [],
        search: '',
        loading: false,
        showStaffInfoDialog: false,
        showStaff: null
    }),
    methods: {
        getResources() {
            this.resources = [];
            this.loading = true;
            this.$api.post('/api/resourcebooking/resource/get_available_by_room', {bookings: this.bookings.map(b => ({start: b.start, end: b.end})), original_list: this.resourceIds, pending: this.pendingSelections}).then(response => {
                response.json().then(resourceIds => {
                    this.resources = this.resourceIds.map(id => {
                        let resource = this.allResources.find(x => x.id == id);
                        let available = resourceIds.includes(id);
                        let selected = this.selectedResourceIds.includes(id);
                        return {
                            id,
                            name: resource.lastname,
                            description: resource.description,
                            imagekey: resource.imagekey,
                            disabled: !available && !selected,
                            selected: selected
                        }
                    });
                    this.loading = false;
                });
            });
        },
        doShowStaffInfoDialog(staff) {
            this.showStaffInfoDialog = true;
            this.showStaff = staff;
        }
    },
    mounted() {
        this.getResources()
    }
}
</script>
